import { render } from "./ArrowUpIcon.vue?vue&type=template&id=3abcd3e0"
import script from "./ArrowUpIcon.vue?vue&type=script&lang=js"
export * from "./ArrowUpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__